import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "container role-list"
};
const _hoisted_2 = {
  class: "handle-box"
};
const _hoisted_3 = ["data-id"];
const _hoisted_4 = {
  class: "context-msg-key"
};
const _hoisted_5 = {
  class: "fr"
};
const _hoisted_6 = {
  class: "context-msg-content"
};
const _hoisted_7 = {
  class: "remove-item"
};
const _hoisted_8 = {
  class: "dialog-footer"
};
import { Delete, Plus } from "@element-plus/icons-vue";
import { onMounted, reactive, ref } from "vue";
import { httpGet, httpPost } from "@/utils/http";
import { ElMessage } from "element-plus";
import { copyObj, removeArrayItem } from "@/utils/libs";
import { Sortable } from "sortablejs";
import Compressor from "compressorjs";
import { showMessageError } from "@/utils/dialog";
export default {
  __name: 'Apps',
  setup(__props) {
    const showDialog = ref(false);
    const parentBorder = ref(true);
    const childBorder = ref(true);
    const tableData = ref([]);
    const sortedTableData = ref([]);
    const role = ref({
      context: []
    });
    const formRef = ref(null);
    const optTitle = ref("");
    const loading = ref(true);
    const rules = reactive({
      name: [{
        required: true,
        message: "请输入用户名",
        trigger: "blur"
      }],
      key: [{
        required: true,
        message: "请输入应用标识",
        trigger: "blur"
      }],
      icon: [{
        required: true,
        message: "请输入应用图标",
        trigger: "blur"
      }],
      sort: [{
        required: true,
        message: "请输入排序数字",
        trigger: "blur"
      }, {
        type: "number",
        message: "请输入有效数字"
      }],
      hello_msg: [{
        required: true,
        message: "请输入打招呼信息",
        trigger: "change"
      }]
    });
    const appTypes = ref([]);
    const models = ref([]);
    const messageRoles = ref(["system", "user", "assistant"]);
    onMounted(() => {
      fetchData();

      // get chat models
      httpGet("/admin/model/list?enable=1").then(res => {
        models.value = res.data;
      }).catch(() => {
        ElMessage.error("获取AI模型数据失败");
      });

      // get app type
      httpGet("/admin/app/type/list?enable=1").then(res => {
        appTypes.value = res.data;
      }).catch(() => {
        ElMessage.error("获取应用分类数据失败");
      });
    });
    const fetchData = () => {
      // 获取应用列表
      httpGet("/admin/role/list").then(res => {
        // 初始化数据
        // const arr = res.data;
        // for (let i = 0; i < arr.length; i++) {
        //   if(arr[i].model_id == 0){
        //     arr[i].model_id = ''
        //   }
        // }
        tableData.value = res.data;
        sortedTableData.value = copyObj(tableData.value);
        loading.value = false;
      }).catch(() => {
        ElMessage.error("获取聊天应用失败");
      });
      const drawBodyWrapper = document.querySelector(".el-table__body tbody");
      // 初始化拖动排序插件
      Sortable.create(drawBodyWrapper, {
        sort: true,
        animation: 500,
        onEnd({
          newIndex,
          oldIndex,
          from
        }) {
          if (oldIndex === newIndex) {
            return;
          }
          const sortedData = Array.from(from.children).map(row => row.querySelector(".sort").getAttribute("data-id"));
          const ids = [];
          const sorts = [];
          sortedData.forEach((id, index) => {
            ids.push(parseInt(id));
            sorts.push(index + 1);
            tableData.value[index].sort_num = index + 1;
          });
          httpPost("/admin/role/sort", {
            ids: ids,
            sorts: sorts
          }).catch(e => {
            ElMessage.error("排序失败：" + e.message);
          });
        }
      });
    };
    const roleSet = (filed, row) => {
      httpPost("/admin/role/set", {
        id: row.id,
        filed: filed,
        value: row[filed]
      }).then(() => {
        ElMessage.success("操作成功！");
      }).catch(e => {
        ElMessage.error("操作失败：" + e.message);
      });
    };

    // 编辑
    const curIndex = ref(0);
    const rowEdit = function (index, row) {
      optTitle.value = "修改应用";
      curIndex.value = index;
      role.value = copyObj(row);
      showDialog.value = true;
    };
    const addRole = function () {
      optTitle.value = "添加新应用";
      role.value = {
        context: []
      };
      showDialog.value = true;
    };
    const save = function () {
      formRef.value.validate(valid => {
        if (valid) {
          showDialog.value = false;
          httpPost("/admin/role/save", role.value).then(() => {
            ElMessage.success("操作成功");
            fetchData();
          }).catch(e => {
            ElMessage.error("操作失败，" + e.message);
          });
        }
      });
    };
    const removeRole = function (row) {
      httpGet("/admin/role/remove?id=" + row.id).then(() => {
        ElMessage.success("删除成功！");
        tableData.value = removeArrayItem(tableData.value, row, (v1, v2) => {
          return v1.id === v2.id;
        });
      }).catch(() => {
        ElMessage.error("删除失败！");
      });
    };
    const addContext = function () {
      if (!role.value.context) {
        role.value.context = [];
      }
      role.value.context.push({
        role: "",
        content: ""
      });
    };
    const removeContext = function (index) {
      role.value.context.splice(index, 1);
    };

    // 图片上传
    const uploadImg = file => {
      // 压缩图片并上传
      new Compressor(file.file, {
        quality: 0.6,
        success(result) {
          const formData = new FormData();
          formData.append("file", result, result.name);
          // 执行上传操作
          httpPost("/admin/upload", formData).then(res => {
            role.value.icon = res.data.url;
            ElMessage.success("上传成功");
          }).catch(e => {
            ElMessage.error("上传失败:" + e.message);
          });
        },
        error(e) {
          ElMessage.error("上传失败:" + e.message);
        }
      });
    };
    const isGenerating = ref(false);
    const metaPrompt = ref("");
    const generatePrompt = row => {
      if (metaPrompt.value === "") {
        return showMessageError("请输入元提示词");
      }
      isGenerating.value = true;
      httpPost("/prompt/meta", {
        prompt: metaPrompt.value
      }).then(res => {
        row.content = res.data;
        isGenerating.value = false;
      }).catch(e => {
        showMessageError("生成失败：" + e.message);
        isGenerating.value = false;
      });
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_popconfirm = _resolveComponent("el-popconfirm");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_text = _resolveComponent("el-text");
      const _component_el_popover = _resolveComponent("el-popover");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
        type: "primary",
        icon: _unref(Plus),
        onClick: addRole
      }, {
        default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("新增")])),
        _: 1
      }, 8, ["icon"])]), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: tableData.value,
          border: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "expand"
          }, {
            default: _withCtx(props => [_createElementVNode("div", null, [_createVNode(_component_el_table, {
              data: props.row.context,
              border: childBorder.value
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                label: "对话应用",
                prop: "role",
                width: "120"
              }), _createVNode(_component_el_table_column, {
                label: "对话内容",
                prop: "content"
              })]),
              _: 2
            }, 1032, ["data", "border"])])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "应用名称",
            prop: "name"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", {
              class: "sort",
              "data-id": scope.row.id
            }, [_cache[11] || (_cache[11] = _createElementVNode("i", {
              class: "iconfont icon-drag"
            }, null, -1)), _createTextVNode(" " + _toDisplayString(scope.row.name), 1)], 8, _hoisted_3)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "应用类型",
            prop: "type_name"
          }), _createVNode(_component_el_table_column, {
            label: "应用标识",
            prop: "key"
          }), _createVNode(_component_el_table_column, {
            label: "绑定模型",
            prop: "model_name"
          }), _createVNode(_component_el_table_column, {
            label: "启用状态"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_switch, {
              modelValue: scope.row['enable'],
              "onUpdate:modelValue": $event => scope.row['enable'] = $event,
              onChange: $event => roleSet('enable', scope.row)
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "应用图标",
            prop: "icon"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_image, {
              src: scope.row.icon,
              style: {
                "width": "45px",
                "height": "45px",
                "border-radius": "50%"
              }
            }, null, 8, ["src"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "打招呼信息",
            prop: "hello_msg"
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            width: "150"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_button, {
              size: "small",
              type: "primary",
              onClick: $event => rowEdit(scope.$index, scope.row)
            }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("编辑")])),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_popconfirm, {
              title: "确定要删除当前应用吗?",
              onConfirm: $event => removeRole(scope.row),
              width: 200
            }, {
              reference: _withCtx(() => [_createVNode(_component_el_button, {
                size: "small",
                type: "danger"
              }, {
                default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("删除")])),
                _: 1
              })]),
              _: 2
            }, 1032, ["onConfirm"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])]),
        _: 1
      }), _createVNode(_component_el_dialog, {
        modelValue: showDialog.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => showDialog.value = $event),
        title: optTitle.value,
        "close-on-click-modal": false,
        width: "50%"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_8, [_createVNode(_component_el_button, {
          onClick: _cache[8] || (_cache[8] = $event => showDialog.value = false)
        }, {
          default: _withCtx(() => _cache[20] || (_cache[20] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: save
        }, {
          default: _withCtx(() => _cache[21] || (_cache[21] = [_createTextVNode("保存")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: role.value,
          "label-width": "120px",
          ref_key: "formRef",
          ref: formRef,
          "label-position": "left",
          rules: rules
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "应用名称：",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: role.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => role.value.name = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "应用分类：",
            prop: "tid"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: role.value.tid,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => role.value.tid = $event),
              filterable: "",
              placeholder: "请选择分类",
              clearable: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appTypes.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "应用标志：",
            prop: "key"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: role.value.key,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => role.value.key = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "应用图标：",
            prop: "icon"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: role.value.icon,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => role.value.icon = $event)
            }, {
              append: _withCtx(() => [_createVNode(_component_el_upload, {
                "auto-upload": true,
                "show-file-list": false,
                "http-request": uploadImg
              }, {
                default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode(" 上传 ")])),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "绑定模型：",
            prop: "model_id"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: role.value.model_id,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => role.value.model_id = $event),
              filterable: "",
              placeholder: "请选择模型",
              clearable: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(models.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "打招呼信息：",
            prop: "hello_msg"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: role.value.hello_msg,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => role.value.hello_msg = $event),
              autocomplete: "off"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "上下文信息：",
            prop: "context"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table, {
              data: role.value.context,
              border: childBorder.value,
              size: "small"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                label: "对话应用",
                width: "120"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_select, {
                  modelValue: scope.row.role,
                  "onUpdate:modelValue": $event => scope.row.role = $event,
                  placeholder: "Role"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messageRoles.value, value => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: value,
                      label: value,
                      value: value
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"])]),
                _: 1
              }), _createVNode(_component_el_table_column, {
                label: "对话内容"
              }, {
                header: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_cache[16] || (_cache[16] = _createElementVNode("span", null, "对话内容", -1)), _createElementVNode("span", _hoisted_5, [_createVNode(_component_el_button, {
                  type: "primary",
                  onClick: addContext,
                  size: "small"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [_createVNode(_unref(Plus))]),
                    _: 1
                  }), _cache[15] || (_cache[15] = _createTextVNode(" 增加一行 "))]),
                  _: 1
                })])])]),
                default: _withCtx(scope => [_createElementVNode("div", _hoisted_6, [_withDirectives(_createVNode(_component_el_input, {
                  type: "textarea",
                  rows: 3,
                  modelValue: scope.row.content,
                  "onUpdate:modelValue": $event => scope.row.content = $event,
                  autocomplete: "off"
                }, null, 8, ["modelValue", "onUpdate:modelValue"]), [[_directive_loading, isGenerating.value]]), _createElementVNode("span", _hoisted_7, [_createVNode(_component_el_tooltip, {
                  effect: "dark",
                  content: "删除当前行",
                  placement: "right"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_button, {
                    circle: "",
                    type: "danger",
                    size: "small"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_icon, {
                      onClick: $event => removeContext(scope.$index)
                    }, {
                      default: _withCtx(() => [_createVNode(_unref(Delete))]),
                      _: 2
                    }, 1032, ["onClick"])]),
                    _: 2
                  }, 1024)]),
                  _: 2
                }, 1024), _createVNode(_component_el_popover, {
                  placement: "right",
                  width: 400,
                  trigger: "click"
                }, {
                  reference: _withCtx(() => [_createVNode(_component_el_button, {
                    type: "primary",
                    circle: "",
                    size: "small",
                    class: "icon-btn"
                  }, {
                    default: _withCtx(() => _cache[17] || (_cache[17] = [_createElementVNode("i", {
                      class: "iconfont icon-linggan"
                    }, null, -1)])),
                    _: 1
                  })]),
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    type: "textarea",
                    rows: 3,
                    modelValue: metaPrompt.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => metaPrompt.value = $event),
                    autocomplete: "off",
                    placeholder: "请您输入要 AI实现的目标，任务或者需要AI扮演的角色？"
                  }, null, 8, ["modelValue"]), _createVNode(_component_el_row, {
                    class: "text-line"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_text, {
                      type: "info",
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[18] || (_cache[18] = [_createTextVNode("使用 AI 生成 System 预设指令")])),
                      _: 1
                    }), _createVNode(_component_el_button, {
                      class: "generate-btn",
                      size: "small",
                      onClick: $event => generatePrompt(scope.row),
                      color: "#5865f2",
                      disabled: isGenerating.value
                    }, {
                      default: _withCtx(() => _cache[19] || (_cache[19] = [_createElementVNode("i", {
                        class: "iconfont icon-chuangzuo"
                      }, null, -1), _createElementVNode("span", null, "立即生成", -1)])),
                      _: 2
                    }, 1032, ["onClick", "disabled"])]),
                    _: 2
                  }, 1024)]),
                  _: 2
                }, 1024)])])]),
                _: 1
              })]),
              _: 1
            }, 8, ["data", "border"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "启用状态"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: role.value.enable,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => role.value.enable = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "title"])])), [[_directive_loading, loading.value]]);
    };
  }
};